module.exports = __webpack_public_path__ + "img/ic30Phone.438f50ab.svg";